import imgPvc from '../../../assets/onboarding/products/pvc.jpg';
import imgCement from '../../../assets/onboarding/products/cement.jpg';
import imgDrywall from '../../../assets/onboarding/products/drywall.jpg';

export const ONBOARDING_MOCK_PRODUCTS = [
  {
    code: 'PVC-SUM-20',
    name: 'SUMIDERO SIFÓNICO PVC 20X20',
    price: '$9.75',
    stock: 866,
    image: imgPvc,
  },
  {
    code: 'CEM-C2-25',
    name: 'SACO CEMENTO COLA FLEXIBLE C2',
    price: '$14.90',
    stock: 1044,
    image: imgCement,
  },
  {
    code: 'DRY-12-4X8',
    name: 'PLACA DRYWALL 1/2" 4X8',
    price: '$8.40',
    stock: 320,
    image: imgDrywall,
  },
] as const;
